module.exports = __webpack_public_path__ + "img/组 696@2x.f1e0db20.webp";